import $ from 'jquery';

Drupal.behaviors.beijertechgroupStatusMessages = {
  attach: function (context) {
    const $button = $('.close-status-message', context);

    $button.unbind().on('beijertechgroupStatusMessages').on('click', function() {
      let $region = $(this).closest('.status-message'),
        ariaHidden = $region.attr('aria-hidden');
      $region.addClass('status-message--hidden');

      if (ariaHidden === 'false') {
        $region.attr('aria-hidden', 'true');
      }
    });
  }
};
